import React, { useState, useRef } from 'react';
import '../Styles/ContactUs.css';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt,FaWhatsapp } from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import wisdomLogo from '../Assets/Wisdomlogo.png'; // Placeholder image, replace with actual logo path
const ContactUs = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const formRef = useRef();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_qdnw4fo',      // Replace with your EmailJS service ID
        'template_jzle7ks',     // Replace with your EmailJS template ID
        formRef.current,
        'z18Vs0M6fx5ixQIW9'       // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log(result.text);
          alert('✅ Message sent!');
          setForm({ name: '', email: '', message: '' });
        },
        (error) => {
          console.log(error.text);
          alert('❌ Failed to send message.');
        }
      );
  };

  return (
    <section className="contact-section" id='contact'>
      <h2 className='contact-head'>Contact Us</h2>
      <div className="contact-container">
        <div className="contact-details">
          <div className="contact-image">
            <img src={wisdomLogo} alt="Wisdom logo" className="wisdom-logo"/>
          </div>
          <div>
          <p><FaEnvelope />info@gainwissdom.in</p>
          <p><FaPhoneAlt /><FaWhatsapp /> +91 99439 36999</p>
          <p><FaMapMarkerAlt /> Coimbatore, Tamil Nadu, India</p></div>
        </div>
        <div>
          <form className="contact-form" ref={formRef} onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={form.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={form.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={form.message}
              onChange={handleChange}
              required
            />
            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
